import Icon from "components/Elements/Icon/Icon";
import SaveMail from "components/Reusable/SaveMail/SaveMail";
import { ButtonAccessability } from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";

import styles from "./saveForGoodMarketingElem.module.scss";

const SaveForGoodMarketingElem = ({
  isSettingItem,
}: {
  isSettingItem?: boolean;
}) => {
  const { getTextByKey } = useContent();
  const { setModal, closeModal } = useModal();

  const showSaveModal = () => {
    setModal({
      modal: SaveMail,
      modalSize: "full-modal",
      props: {
        isMailSender: false,
        subscribeOnly: true,
        closeElement: () => {
          closeModal();
        },
      },
    });
  };

  return (
    <ButtonAccessability
      onClick={showSaveModal}
      buttonClassName={`${styles.button} ${
        isSettingItem ? styles.settingItem : ""
      }`}
    >
      <Icon name="jm-marketing-icon" />
      <span className={styles.save}>{getTextByKey("save-mail-text")}</span>
    </ButtonAccessability>
  );
};

export default SaveForGoodMarketingElem;
